import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import CeaseList from 'CustomerRequests/Cease/pages/CeaseList';
import SubmitCeaseRequest from 'CustomerRequests/Cease/pages/SubmitCeaseRequest';
import CeaseDetails from 'CustomerRequests/Cease/pages/CeaseDetails';

const CeaseRouter: FC = () => {
  return (
    <Routes>
      <Route index element={<CeaseList />} />
      <Route path="new" element={<SubmitCeaseRequest />} />
      <Route path=":id" element={<CeaseDetails />} />
    </Routes>
  );
};

export default CeaseRouter;
